import { ValgStateActionTypes, ValgState, TOGGLE_VILKAR, UPDATE_VALG } from './Types';

export const initialState: ValgState = {
    antallBarn: 1,
    bFamiliesituasjon: undefined,
    visVilkar: false,
};

export function valgReducer(state: ValgState = initialState, action: ValgStateActionTypes): ValgState {
    const newState = getNewState();
    return newState;

    function getNewState(): ValgState {
        switch (action.type) {
            case UPDATE_VALG: {
                return {
                    ...state,
                    ...action.payload,
                };
            }
            case TOGGLE_VILKAR: {
                return {
                    ...state,
                    visVilkar: !state.visVilkar,
                };
            }
            default:
                return state;
        }
    }
}
